import { getType } from './types';

export const isEmpty = (value: any) => {
  if (['Object', 'Array'].indexOf(getType(value)) > -1) {
    return Object.keys(value as any).length === 0;
  }
  return !value;
};

export const isNotEmpty = (value: any) => !isEmpty(value);

export const isEmptyString = (s: string) => s.trim().length === 0;
